import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { useGetGiveawayQuery, useUpdateServingsMutation } from '../../api/giveawayApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import buttons from '../../styles/shared/buttons.module.css';

export default function GiveawayServingsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const showToast = useToast();

  const { data: giveaway, isLoading, isError, error } = useGetGiveawayQuery(id);
  const [updateServings, { isLoading: isSaving }] = useUpdateServingsMutation();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: { servingsLeft: null },
  });

  useEffect(() => {
    if (giveaway) reset({ servingsLeft: giveaway.servings_left ?? null });
  }, [giveaway, reset]);

  useEffect(() => {
    if (isError) showToast('error', 'Giveaways', errMsg(error, 'Could not load giveaway.'));
  }, [isError, error, showToast]);

  const onSave = async (data) => {
    try {
      await updateServings({
        id,
        groupId: giveaway.group_id,
        servingsLeft: data.servingsLeft ?? 0,
      }).unwrap();
      showToast('success', 'Giveaways', 'Servings updated.');
      navigate('/host/giveaways');
    } catch (err) {
      showToast('error', 'Giveaways', errMsg(err, 'Could not update servings.'));
    }
  };

  if (isLoading) return <p className="textMuted">Loading…</p>;
  if (!giveaway) return null;

  return (
    <EntityFormPage title="Update servings" backTo="/host/giveaways">
      <form onSubmit={handleSubmit(onSave)}>
        <p className="textMuted mb-3">
          New servings count for <strong>{giveaway.title}</strong>.
        </p>
        <Controller
          name="servingsLeft"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Servings left</label>
              <InputNumber
                inputId={field.name}
                className="w-full mb-3"
                inputClassName="w-full"
                value={field.value}
                onValueChange={(e) => field.onChange(e.value)}
                min={0}
                useGrouping={false}
              />
            </div>
          )}
        />
        <Button type="submit" label="Save" className={buttons.saveBtn} loading={isSaving} />
      </form>
    </EntityFormPage>
  );
}
